module.exports = __webpack_public_path__ + "static/img/bg_2_3.59a4cc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_2_3.png
// module id = KbDd
// module chunks = 3